/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DistributionChannelListQuery
 */
export interface DistributionChannelListQuery {
    /**
     * 
     * @type {string}
     * @memberof DistributionChannelListQuery
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DistributionChannelListQuery
     */
    showNonEffective?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DistributionChannelListQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DistributionChannelListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DistributionChannelListQuery
     */
    limit?: number | null;
}

export function DistributionChannelListQueryFromJSON(json: any): DistributionChannelListQuery {
    return DistributionChannelListQueryFromJSONTyped(json, false);
}

export function DistributionChannelListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributionChannelListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : json['label'],
        'showNonEffective': !exists(json, 'showNonEffective') ? undefined : json['showNonEffective'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function DistributionChannelListQueryToJSON(value?: DistributionChannelListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'showNonEffective': value.showNonEffective,
        'showDeleted': value.showDeleted,
        'offset': value.offset,
        'limit': value.limit,
    };
}


